import PageList from './PageList';

import './PageList.scss';

export default PageList;
